module.exports = __webpack_public_path__ + "static/mobile-house-f1be40b909363d57be36a78d9b5c6ad8.png";